export const roleToStr = (role: string) => {
  switch (role) {
    case "admin":
      return "スーパーバイザー";
    case "general":
      return "一般";
    default:
      return "";
  }
};
